import {Component} from '@angular/core';
import {AbstractFields} from '../_abstract';

@Component({
    selector: 'organization-bank-fields',
    templateUrl: './organization-bank.component.html'
})
export class OrganizationBankFieldsComponent extends AbstractFields {

}
